//import rrwebPlayer from "rrweb-player";
import "./rrweb.min.css"; //"https://cdn.jsdelivr.net/npm/rrweb@latest/dist/rrweb.min.css";
import {Replayer} from "rrweb";
import m from "mithril";
import tools from "../../tools/tools";
import {ButtonGroup, Icons, Icon, Dialog} from "../../plugins/construct-ui/index";
import lzwCompress from "lzwcompress";
import pf from "../../pf";

export default () => {
	let player = null;
	let playerpreviousstyle = undefined;
	let showsavedialog = false;
	let saving = false;
	let saveinfo = {};
	let playing = false;
	let firsttimestarted = false;

	return {
		view: (v) => {
			return [
				m(
					".playback-player-wrapper",
					{
						style: `width: 100vw;
                        height: 100vh;
                        position: fixed;
                        top: 0;
                        left: 0;
                        background-color: #0984e3;
                        z-index: 100;
                        display: grid;
                        place-items: center;
                        ${
													showsavedialog
														? ""
														: "grid-template-rows: 90vh 10vh;grid-template-areas: 'player' 'controller';"
												}
                        `,
					},
					[
						showsavedialog
							? [
									m(
										".save-form-dialog",
										{
											style: `background-color: white; padding: 2rem; width: clamp(30rem, 90%, 70rem); border-radius: 1rem; color: black;`,
										},
										[
											tools.TextField("Title", saveinfo.title, (t) => {
												saveinfo.title = t;
											}),
											tools.TextAreaField("Description", saveinfo.description, (t) => {
												saveinfo.description = t;
											}),
											tools.Button(
												"Save",
												undefined,
												undefined,
												() => {
													saving = true;
													pf.APIAction("GetData", {
														code: "videos",
														new: true,
														video: v.attrs.events || "dummy",
														description: saveinfo.description,
														title: saveinfo.title,
													}).then((r) => {
														if (r.success) {
															pf.Inform("Success");
															showsavedialog = false;
														} else {
															pf.Inform("Something went wrong. Please retry.", true);
														}
														saving = false;
														if (player) {
															player.wrapper.style = playerpreviousstyle;
															playerpreviousstyle = undefined;
														}
														m.redraw();
													});
												},
												false,
												{},
												saving
											),
											tools.Button(
												"Cancel",
												undefined,
												undefined,
												() => {
													showsavedialog = false;
													saving = false;
													if (player) {
														player.wrapper.style = playerpreviousstyle;
														playerpreviousstyle = undefined;
													}
												},
												true
											),
										]
									),
							  ]
							: [
									m(".playback-player", {
										style: `background-color: white; width: 100%; height: 100%; grid-area: player; transform:scale(0.8);
										display: ${showsavedialog ? "none" : "block"};`,
										oncreate: (u) => {
											if (v.attrs.events) {
												firsttimestarted = false;
												// let uncompressed = JSON.parse(pf.decompress(v.attrs.events));
												let uncompressed = JSON.parse(lzwCompress.unpack(v.attrs.events));
												player = new Replayer(uncompressed, {
													root: u.dom, // customizable root element
													skipInactive: false,
													showDebug: false,
													showWarning: false,
													autoPlay: true,
													mouseTail: true,
													liveMode: false,
												});

												player.on("start", () => {
													// if (!firsttimestarted) {
													// 	// console.log("playing started. first time ")
													// 	firsttimestarted = true;
													// 	player.pause();
													// }
													// console.log("playing");
													playing = true;
													m.redraw();
												});
												player.on("pause", () => {
													// console.log("pausing");
													playing = false;
													m.redraw();
												});
												player.on("finish", () => {
													playing = false;
													m.redraw();
												});

												player.play();
											}
										},
										onremove: (u) => {
											// console.log("being removed");
										},
									}),
									m(
										".play-controller",
										{
											style: `grid-area: controller; 
                            display: grid;
                            place-items: center;`,
										},
										[
											m(ButtonGroup, [
												tools.Button(
													"",
													Icons.ARROW_LEFT,
													undefined,
													() => {
														if (player) player.play(0);
														playing = true;
													},
													undefined,
													{
														title: "From Start",
													}
												),
												playing
													? tools.Button(
															"",
															Icons.PAUSE,
															undefined,
															() => {
																if (player) player.pause();
																playing = false;
															},
															undefined,
															{
																title: "Pause",
															}
													  )
													: tools.Button(
															"",
															Icons.PLAY,
															undefined,
															() => {
																if (player) player.play();
															},
															undefined,
															{
																title: "Play",
															}
													  ),
												tools.Button("", Icons.FAST_FORWARD, undefined, () => {}, undefined, {
													title: "Forward 3s",
												}),
												tools.Button(
													"Close",
													Icons.X_SQUARE,
													undefined,
													() => {
														// console.log("3");
														if (v.attrs.onstop) v.attrs.onstop();
													},
													undefined,
													{
														title: "Stop",
													}
												),
												v.attrs.new &&
													tools.Button(
														"Save Video",
														Icons.SAVE,
														undefined,
														() => {
															//console.log(player);
															playerpreviousstyle = player.wrapper.style;
															player.wrapper.style = "display: none;";
															playing = false;
															showsavedialog = true;
															m.redraw();
														},
														undefined,
														{
															title: "Save",
														}
													),
											]),
										]
									),
							  ],
					]
				),
			];
		},
	};
};
